if (!customElements.get('piex-banner-video')) {
  customElements.define('piex-banner-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-video-toggle]');
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.userPaused = false;
      this.manualMotion = false;
      this.loaded = false;
      this.failed = false;
      this.video.muted = true;
      const options = {signal: this.abort.signal};
      this.querySelector('.piex-banner-video-controls').hidden = false;
      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (!this.userPaused) this.manualMotion = true;
        this.sync();
      }, options);
      this.querySelector('[data-video-replay]').addEventListener('click', () => {
        this.userPaused = false;
        this.manualMotion = true;
        this.video.currentTime = 0;
        this.sync();
      }, options);
      ['play', 'pause', 'ended'].forEach(event => this.video.addEventListener(event, () => this.updateButton(), options));
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.dataset.failed = 'true';
        this.video.pause();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => {
        this.manualMotion = false;
        this.sync();
      }, options);
      this.modeObserver = new MutationObserver(() => this.sync());
      this.modeObserver.observe(document.documentElement, {attributes:true, attributeFilter:['data-piex-mode']});
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, {threshold:0.05});
      this.intersection.observe(this);
    }
    shouldPlay() {
      return this.isConnected && !this.failed && this.visible && !document.hidden &&
        document.documentElement.dataset.piexMode === 'halloween' && !this.userPaused &&
        (!this.motion.matches || this.manualMotion) && (this.dataset.editor !== 'true' || this.manualMotion);
    }
    sync() {
      if (!this.shouldPlay()) {
        this.video.pause();
        this.updateButton();
        return;
      }
      if (!this.loaded) {
        if (navigator.connection && navigator.connection.saveData && !this.manualMotion) {
          this.video.pause(); this.updateButton(); return;
        }
        if (document.readyState !== 'complete' && !this.manualMotion && !this.waitOver) {
          if (!this.waitingLoad) {
            this.waitingLoad = true;
            const go = () => { if (this.waitOver) return; this.waitOver = true; this.sync(); };
            window.addEventListener('load', go, {once: true, signal: this.abort.signal});
            setTimeout(go, 3000); // Piex (v9d): como mucho 3 segundos de espera aunque una aplicacion retrase el evento load
          }
          this.video.pause(); this.updateButton(); return;
        }
        this.video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
        this.loaded = true;
        this.video.load();
      }
      this.video.play().then(() => {
        if (!this.shouldPlay()) this.video.pause();
        this.updateButton();
      }).catch(() => this.updateButton());
    }
    updateButton() {
      this.toggle.textContent = this.video.paused ? 'Reproducir' : 'Pausar';
      this.toggle.setAttribute('aria-label', this.video.paused ? 'Reproducir vídeo de maquillaje' : 'Pausar vídeo de maquillaje');
    }
    disconnectedCallback() {
      this.video?.pause();
      this.abort?.abort();
      this.modeObserver?.disconnect();
      this.intersection?.disconnect();
    }
  });
}
